module.exports = __webpack_public_path__ + "img/sleeve_cap.2f807b71.png";